import { render, staticRenderFns } from "./AmazonPayRecv.vue?vue&type=template&id=4452b15f&"
import script from "./AmazonPayRecv.vue?vue&type=script&lang=js&"
export * from "./AmazonPayRecv.vue?vue&type=script&lang=js&"
import style0 from "./AmazonPayRecv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AmazonPayRecv.vue"
export default component.exports